import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const contactInfo: ISVGPersonalProps = {
  viewBox: '0 0 36 36',
  content: (
    <>
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_2984" data-name="Rectangle 2984" width="15.858" height="16.915" fill="currentColor" />
        </clipPath>
      </defs>
      <g id="contact_info_icon" data-name="contact info icon" transform="translate(-269.499 -634.542)">
        <g id="border" transform="translate(269.499 634.542)" fill="#fff" stroke="currentColor" strokeWidth="1">
          <rect width="36" height="36" rx="18" stroke="none" />
          <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="none" />
        </g>
        <g id="icon" transform="translate(279.5 644.085)">
          <g id="Group_3750" data-name="Group 3750" clipPath="url(#clip-path)">
            <path
              id="Path_7067"
              data-name="Path 7067"
              d="M13.887,0H3.028A1.973,1.973,0,0,0,1.057,1.971v1.2H.529a.529.529,0,0,0,0,1.057h.529V6.343H.529a.529.529,0,1,0,0,1.057h.529V9.515H.529a.529.529,0,1,0,0,1.057h.529v2.114H.529a.529.529,0,1,0,0,1.057h.529v1.2a1.973,1.973,0,0,0,1.971,1.971H13.887a1.973,1.973,0,0,0,1.971-1.971V1.971A1.973,1.973,0,0,0,13.887,0M14.8,14.944a.914.914,0,0,1-.913.913H3.028a.914.914,0,0,1-.913-.913v-1.2h.529a.529.529,0,1,0,0-1.057H2.114V10.572h.529a.529.529,0,1,0,0-1.057H2.114V7.4h.529a.529.529,0,1,0,0-1.057H2.114V4.229h.529a.529.529,0,0,0,0-1.057H2.114v-1.2a.914.914,0,0,1,.913-.913H13.887a.914.914,0,0,1,.913.913Z"
              fill="currentColor"
            />
            <path
              id="Path_7068"
              data-name="Path 7068"
              d="M183.349,95.638a2.643,2.643,0,1,0-2.643-2.643,2.643,2.643,0,0,0,2.643,2.643m0-4.229a1.586,1.586,0,1,1-1.586,1.586,1.586,1.586,0,0,1,1.586-1.586"
              transform="translate(-174.363 -87.18)"
              fill="currentColor"
            />
            <path
              id="Path_7069"
              data-name="Path 7069"
              d="M139.758,256a4.234,4.234,0,0,0-4.229,4.229.529.529,0,0,0,.529.529h7.4a.529.529,0,0,0,.529-.529A4.234,4.234,0,0,0,139.758,256m-3.128,3.7a3.172,3.172,0,0,1,6.255,0Z"
              transform="translate(-130.772 -247.013)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </>
  ),
};
